import en_routes from "./route_translations/en_routes";
const en = {
  ...en_routes,
  back: "Back",
  close: "Close",
  play: "Play",
  resume: "Resume",
  content_text: "Watch {artist} on FlixLatino for only $3.99",
  load_more: "Load More",
  more_info: "More Info",
  detail_page: {
    subscribe: "Subscribe now",
    trailer: "Trailer",
    about: "About",
    country: "Country of Origin: ",
    directors: "Directed by: ",
    cast: "Cast: ",
    next_episodes: "Next Episodes",
    view_all_episodes: "View all episodes",
    episodes: "Episodes",
    similar_content: "Similar Content",
    season: "Season",
    play: "Watch Now",
    watch_and_stream_movies: "{movie} {'|'} Watch & stream movies online",
    watch_episode_alt:
      "Watch {episode} online {'|'} Stream {show} Season {season}",
    stream_tv_shows: "{title} {'|'} Stream TV shows",
    next_episode_alt:
      "Watch {show} online {'|'} Stream season {season}, {episode}",
    next_episode_title: "Season {season}, {episode}",
  },
  home: {
    meta: {
      title: "Browse TV Shows & Movies in Spanish Online | FlixLatino",
      description:
        "FlixLatino offers the best Spanish films and series from the Spanish-speaking world. Featuring Latino movies, Spanish movies, and family friendly Spanish-language entertainment. Discover countless hours of Spanish series, movies, and programming from your country – all ad free for just $3.99 per month. Your culture, your movies.",
    },
  },
  browse: {
    meta: {
      title: "Browse All Content",
      description:
        "Browse the largest collection of entertainment in Spanish worldwide. Sign up for a free trial today.",
    },
  },
  discover: {
    meta: {
      title: "Browse TV Shows & Movies in Spanish Online | FlixLatino",
      description:
        "Discover the largest collection of entertainment in Spanish worldwide. Browse TV shows and movies by country or category. Sign up for a free trial today.",
    },
    title: "Discover",
    subtitle: "Discover Spanish Entertainment, <br /> from around the world",
    search: "Search movies, TV Shows, Actors, Genres...",
    by_country: {
      view_all: "View all",
      content_from: "Content from {country}",
      result_count: "{count} Results",
      title: "Browse content by Country",
      subtitle:
        "Select a country of interest and find all of the top spanish movies and tv shows produced there!  ",
    },
    moods: {
      title: "Discover movies based on your mood",
      subtitle:
        "Select a mood and find all of the top spanish movies and tv shows that match your mood!  ",
      trynow: "Try now",
    },
  },
  checkout: {
    locale: "en_US",
    loading: "Loading...",
    card: {
      number: "Card Number",
      expiration: "Expiration Date",
      cvc: "CVC",
      postal: "Zip Code",
      cardholderName: "Cardholder Name",
    },
    mobile: {
      change_plan: "Change Plan",
      title: "7-Day Free Trial",
      sub_title: "Amount Due Today: ${amount}*",
      confirm: "Start Trial",
      free_trial: "Free Trial",
      free_trial_dias: "7 Days Free Trial",
      smalltext:
        'By pressing the "Start Trial" button, you accept our terms and conditions and certify that you are over 18. You can cancel at any time during your free trial and you will not be charged. To cancel go to your account preferences and press "Cancel Membership"',
      condition:
        "An amount of $ 0.01 will be authorized to validate your credit card which will be returned in full within the next 24 hours",
      bullets: {
        one: "Set up payment for later",
        two: "No charge until {date}",
        three: "Total due after free trial  ${price}",
      },
      plans: {
        basic: "FlixLatino Basic",
        premium: "FlixLatino Premium",
        monthly: "Monthly",
        annual: "Annual",
      },
    },
    title: "Checkout",
    title_trial: "7-Day Free Trial",
    subtitle: "Confirm and start your free 7 day trial.",
    firstname: "First Name",
    lastname: "Last Name",
    credit: "Credit/debit card number",
    exp: "Exp (MM/YY)",
    cvv: "Security Code (CVV)",
    giftcode: "Enter GiftCode",
    plan_details: "View plan details",
    confirm: "Confirm",
    free_trial: "Free trial",
    validating: "Validating...",
    notvalid: "Invalid code",
    willbecharged: "You will be charged on",
    sevendays: "7 days free",
    duetoday: "Due today:",
  },
  body_promo: {
    title: "1000+ hours of entertainment in Spanish",
    subtitle:
      "The most sought after Turkish series. Movies and series from Mexico, Spain, Colombia, Venezuela, Dominican Republic, Peru, and more.",
    button: "Start your free trial",
  },
  register: {
    title: "Set up your account",
    subtitle:
      "Let’s start by setting up your account to access your membership! ",
    email: "Email",
    password: "Password",
    confirm_password: "Confirm your password",
    continue: "Continue",
    account: "Account",
    payment: "Payment",
    account_exists: "This E-mail address is already registered",
    password_not_match: "Passwords do not match",
    password_missing: "Password is required",
  },
  message: {
    hello: "hello world",
  },
  navbar: {
    trial: "Start Free Trial",
    discover: "Discover",
    login: "Log In",
    logout: "Log Out",
    subscribe: "Subscribe now",
    currentLanguage: "EN",
    lang: {
      es: "ES",
      en: "EN",
    },
    logged: {
      movies: "Movies",
      series: "Series & Shows",
      live: "FlixLive",
      my_list: "My List",
      by_country: "Browse by Country",
      preferences: "Account",
      help: "Help",
    },
  },
  plans: {
    title: "Choose your plan",
    subtitle:
      "Enjoy a free trial when you select a plan. Upgrade or cancel* anytime.",
    toggle: {
      monthly: "Monthly",
      annual: "Annual",
    },
    includes: "plan includes",
    most_popular: "MOST POPULAR",
    buttons: {
      monthly: {
        basic: "Subscribe for $3.99",
        premium: "Subscribe now for $4.99",
      },
      annual: {
        basic: "Subscribe for $35.99",
        premium: "Subscribe now for $44.99",
      },
    },
    basic: {
      title: "On demand content for everyone",
      button_title: "FLIXLATINO",
      description:
        "Get started with all of your favorite on-demand TV and movies for you and your whole family for only $3.99",
      bullets: [
        ["Award-winning movies, series and animations", "positive"],
        ["Weekly Premieres (Tuesday, Thursday and Saturday)", "positive"],
        ["Watch in High-Definition, Ad-Free", "positive"],
        ["Access to live-channels", "positive"],
        ["Kids profile (FlixKids)", "positive"],
        ["Cancel anytime", "positive"],
        ["4 screens at the same time (Only 2)", "negative"],
        ["All episodes released at premiere (Tiered release)", "negative"],
        ["Downloads available", "negative"],
      ],
    },
    premium: {
      title: "Enjoy your favorite content wherver you are",
      button_title: "Flixlatino Premium",
      description:
        "Download content for offline viewing and binge on entire season premieres.",
      bullets: [
        ["Award-winning movies, series and animations", "positive"],
        ["Weekly Premieres (Tuesday, Thursday and Saturday)", "positive"],
        ["Watch in High-Definition, Ad-Free", "positive"],
        ["Access to live-channels", "positive"],
        ["Kids profile (FlixKids)", "positive"],
        ["Cancel anytime", "positive"],
        ["4 screens at the same time", "positive"],
        ["All episodes released at premiere", "positive"],
        ["Downloads available", "positive"],
      ],
    },
  },
  login: {
    title: "Log in",
    remember: "Remember me",
    email: "Email address",
    password: "Password",
    forgot: "Forgot your password?",
    continue: "Continue",
    donthave: "Don’t have an account?",
    create: "Create Account",
  },
  landing: {
    miff: {
      title: "Para los amantes del buen cine",
      map_title: "Movies, series and cartoons",
    },
    slider: {
      title: "Your culture, <br> your movies",
      emailPlaceholder: "Enter E-mail",
      startTrial: "Start your free trial",
      value_1: "Commercial free",
      value_2: "Series and movies in  Spanish",
      value_3: "Up to 4 devices at the same time",
    },
    premieres: {
      title: "Premieres",
      browse_all: "Browse all content",
    },
    exclusive_content: {
      title: "Exclusive for FlixLatino",
    },
    promo: {
      title: "Available on your favorite platform",
      featured_actors: "Featured Actors",
      featured_actors_on: "{actor} on FlixLatino",
      featured_actors_desc:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Facilisi ornare sed pretium arcu id laoreet arcu, lectus non.",
      whatch_on_tv: "Watch on TV",
      whatch_on_tv_desc:
        "Watch your favorite content on your Samsung Smart TV, Roku, AppleTV, AndroidTV, Amazon FireTV, and Chromecast.",
      use_our_app: "Download our app",
      use_our_app_desc:
        "Enjoy movies, series and cartoons for the whole family, wherever you want. Download our app and start enjoying today!",
    },
    testimonials: {
      title: "Testimonials",
      member_since: "Member since {date}",
      message: "{message_en}",
    },
    our_products: {
      title: "Our Plans",
      plans: "View Plan details",
      plan_1: {
        plan: "FlixLatino Basic",
        title: "On demand content for everyone",
        description:
          "Get started with all of your favorite on-demand TV and movies for you and your whole family for only $3.99",
        button: "Subscribe for $3.99",
      },
      plan_2: {
        plan: "FlixLatino Premium",
        title: "Enjoy your favorite content wherever you are",
        description:
          "Download content for offline viewing and binge on entire season premieres.",
        button: "Subscribe now for $4.99",
      },
    },
    be_part_of: {
      title: "Be a part of FlixLatino",
      subtitle: "Subscribe and enjoy the best series and movies in Spanish",
      emailPlaceholder: "Enter E-mail",
      startTrial: "Start your free trial",
    },
    language: {
      current: "English",
      current_code: "en",
      other: "Spanish",
      other_code: "es",
    },
  },
  profiles: {
    add: "Add",
    add_title: "Add profile",
    whoiswatching: "Who’s watching?",
    done: "Done",
    manage: "Manage profiles",
    logout: "Log out",
    save: "Save",
    cancel: "Cancel",
    delete: "Delete Profile",
    name: "Name (Required)",
    email: "Email",
    country: "Country of origin",
    birthday: "Date of birth",
    language: "Language",
    flixKids: {
      title: "FlixLatino Kids",
      description:
        "A FlixKids profile will only play TV shows and movies carefully selected for kids, and it won't allow access to account settings.",
    },
  },
  search: {
    search: "Search",
    placeholder: "Search for movies, series, actors, etc.",
    search_results: "Search results for",
    search_results_empty: "No results found for",
    search_results_empty_suggestion: "Try searching for a different term",
    countries: "Countries",
    categories: "Categories",
    actors: "Actors",
    genres: "Genres",
    directors: "Directors",
    deafult_title: "Recommended",
    results: "Results",
    no_results: "No results found",
  },
  preferences: {
    access_until: "You will have access until",
    membersince: "Member since",
    billing: "Billing",
    billing_date: "Your next billing date is ",
    plan_details: "Plan details",
    cancel_membership: "Cancel membership",
    change_password: "Change password",
    change_number: "Change number",
    manage_subscription: "Manage subscription",
    change_plan: "Change plan",
    current_password: "Current password",
    new_password: "New password",
    wrong_password: "Wrong password",
    password_success: "Password changed successfully",
    save_payment_method: "Save payment method",
  },
  floatingmenu: {
    browse: "Browse",
    movies: "Movies",
    series: "Series & Shows",
    live: "FlixLive",
    my_list: "My List",
    countries: "Browse by Country",
  },
  forgotpassword: {
    title: "Forgot password?",
    sent_title: "Email sent",
    email_required: "Email is required",
    email_sent:
      "An email has been sent to you with instructions to reset your password.",
  },
  cancel: {
    title: "Please tell us why you want to Cancel your Membership?",
    continue: "Continue cancelling",
    sub_title: "Select an option below to continue cancelling your membership.",
    reason_a: "I’m not satisfied with the content on FlixLatino",
    reason_b: "FlixLatino is too expensive for me",
    reason_c: "I don’t have time to watch FlixLatino",
    reason_d: "Too much buffering or poor video quality",
    reason_e: "Other",
    cancel_success: "Your membership has been cancelled",
  },
  link: {
    title: "Link your device",
    code: "Enter the code",
    continue: "Continue",
    success: "Your device has been linked",
  },
  meta: {
    about: {
      title: "About Us - FlixLatino",
      description:
        "FlixLatino is a subscription video on demand service (SVOD) offering the largest variety of award-winning movies, series and documentaries originally produced in Spanish. ",
    },
    movie: {
      title: "Watch {title} Online {'|'} FlixLatino",
      description:
        "Watch {title} online. Stream the full movie using your computer or mobile device and share it with friends. Join FlixLatino today.",
    },
    series: {
      title: "Watch {title} Online {'|'} FlixLatino",
      description:
        "Watch full episodes of {title} online. Stream the TV show using your computer or mobile device and share it with friends.",
    },
    episodes: {
      title: "Watch {show} Online: Season {season}, {episode} {'|'} FlixLatino",
      description:
        "Watch full episodes of {show} online. Stream season {season}, {episode} using your computer or mobile device and share it with friends today.",
    },
  },
  termsAndConditions: {
    meta: {
      title: "FlixLatino Terms of Use",
      description:
        "We are a subscription service that provides our members with access to motion pictures, television and other audio-visual content streamed over the Internet",
    },
  },
  about_us: "{en}",
  footer: {
    discover: "Discover",
    movies: "Movies",
    contactUs: "Contact Us",
    news: "Blog",
    search: "Search",
    faq: "FAQ",
    aboutUs: "About Us",
    privacyPolicy: "Privacy Policy",
    termsAndConditions: "Terms & Conditions",
    callUs: "Call toll free at",
  },
  "Get the full experience!": "Get the full experience!",
  "Start your free trial now to get unlimited content":
    "Start your free trial now to get unlimited content",
  "Free Trial": "Free Trial",
  Trending: "Trending",
  "Top Movies in 2024": "Top Movies in 2024",
  "Top Movies Right Now": "Top Movies Right Now",
  "Top TV Shows in 2024": "Top TV Shows in 2024",
  "Top TV Shows Right Now": "Top TV Shows Right Now",
};
export default en;
